import AlertVM from './alert-vm';
export default {
  init: function(node) {
    ko.applyBindings(new AlertVM, node);
  }
};
